/* H+H Natural sections · NG Design · shared script */
(function () {
  if (window.HHNatural) return;
  window.HHNatural = true;
  document.documentElement.classList.add('hh-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  // Fade sections in as they scroll into view
  function reveal(root) {
    var els = (root || document).querySelectorAll('.hh-rv:not(.is-in), .hh-wipe:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  // Collection switch: hover or focus a name to swap the photo
  if (!customElements.get('hh-switch')) {
    customElements.define('hh-switch', class extends HTMLElement {
      connectedCallback() {
        var items = this.querySelectorAll('[data-hh-i]');
        var imgs = this.querySelectorAll('[data-hh-img]');
        this.set = function (i) {
          items.forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-hh-i') === i); });
          imgs.forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-hh-img') === i); });
        };
        var self = this;
        items.forEach(function (el) {
          var i = el.getAttribute('data-hh-i');
          el.addEventListener('mouseenter', function () { self.set(i); });
          el.addEventListener('focus', function () { self.set(i); });
        });
      }
    });
  }

  // Reviews rotator: one quote at a time, pauses on hover
  if (!customElements.get('hh-rotator')) {
    customElements.define('hh-rotator', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('.hh-rr__q'));
        this.i = 0;
        this.paused = false;
        if (this.items.length < 2) return;
        var ms = parseInt(this.getAttribute('data-interval'), 10) || 6000;
        this.addEventListener('mouseenter', function () { self.paused = true; });
        this.addEventListener('mouseleave', function () { self.paused = false; });
        this.timer = setInterval(function () {
          if (self.paused || document.hidden) return;
          self.show(self.items[(self.i + 1) % self.items.length]);
        }, ms);
      }
      show(el) {
        var n = this.items.indexOf(el);
        if (n < 0) return;
        this.items[this.i].classList.remove('is-on');
        this.i = n;
        el.classList.add('is-on');
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  // Theme editor: show the block being edited
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el.classList && el.classList.contains('hh-rr__q')) {
      var r = el.closest('hh-rotator');
      if (r && r.show) { r.paused = true; r.show(el); }
    }
    if (el.hasAttribute && el.hasAttribute('data-hh-i')) {
      var s = el.closest('hh-switch');
      if (s && s.set) s.set(el.getAttribute('data-hh-i'));
    }
  });
})();